module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEQSURBVHgBbVG7scIwEJRkCvDrgPCFENqR6AAyQjqwGRfAkBEZ0wEpEVABUAHuAOjAhAS22WVOjGC4mZP2Tqv7aiWSpmkvCIIloIVe27adN01TAodFURwdTwu5C/KZj+q3XOu67uNjZWgZYyZC3tFG9FcG3jAZPRSOCrIsS7TWCz7meR7FcWzhZyk3+DfwP3D/Q8dRFN2ZIX3VpvWRfeA+SdYSeObXRdt4de/ZNCKWUlYC7fkfYFcdHFPgGX5vxW+BP6IKrICnyh8rVX0JJwi1zu44IDugDPwP8B84VpnWew8hHi7SzxozXxHDl+AekgPfH/egvdQkWPS0RK1dVzd7xMZ3JL8zfAt2c5CoI0d08gTNH38ntwEIqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/api_lite.png
// module id = 0S6j
// module chunks = 46